// extracted by mini-css-extract-plugin
export default {"main":"twWybuinelpKocCeveJL","full":"nO_oR8FdRNaWMWn5xhs_","content":"nikhvf5JGCf6PaghLILb"};